import { IconX } from '@tabler/icons-react';
import { Notification, rem } from '@mantine/core';

const SectionErrorNotification: React.FC = () => {
  const errIcon = <IconX style={{ width: rem(20), height: rem(20) }} />;

  return (
    <Notification
      radius="md"
      withBorder
      withCloseButton={false}
      icon={errIcon}
      color="red"
      title="Oops!"
      styles={{
        root: { boxShadow: 'none' },
      }}
    >
      Něco se pokazilo
    </Notification>
  );
};

export default SectionErrorNotification;
